{
  "app_name": "Jinshuju",
  "ios": {
    "CFBundleDisplayName": "Jinshuju"
  }
}
